import { defineMessages } from "react-intl"

export const commonMessages = defineMessages({
	actionNotAvailable: {
		defaultMessage: "This action is not available.",
		id: "common.actionNotAvailable",
	},
	all: {
		defaultMessage: "All",
		id: "common.all",
	},
	availableFrom: {
		defaultMessage: "Available From",
		id: "common.availableFrom",
	},
	back: {
		defaultMessage: "Back",
		id: "common.back",
	},
	backToInventory: {
		defaultMessage: "Back to my inventory",
		id: "common.backToInventory",
	},
	businessPartnerId: {
		defaultMessage: "Business Partner-ID",
		id: "common.businessPartnerId",
	},
	confirm: {
		defaultMessage: "Confirm",
		id: "common.confirm",
	},
	copyToClipboardSuccess: {
		defaultMessage: "Copied {value} to clipboard.",
		id: "copyToClipboard.success",
	},
	customerType: {
		defaultMessage: "Customer Type",
		id: "common.customerType",
	},
	date: {
		defaultMessage: "Date",
		id: "common.date",
	},
	disabledForVmsVehicle: {
		defaultMessage:
			"Please use {value} to perform this action. Your changes will automatically be applied to Porsche Finder.",
		id: "actionMenu.disabledHint.VmsVehicle",
	},
	edit: {
		defaultMessage: "Edit",
		id: "common.edit",
	},
	error: {
		defaultMessage: "Error",
		id: "common.error",
	},
	finish: {
		defaultMessage: "Finish",
		id: "common.finish",
	},
	forbidden: {
		defaultMessage: "Forbidden",
		id: "common.forbidden",
	},
	hiddenPersonalDataLabel: {
		defaultMessage: "Personal Data is hidden",
		id: "common.hiddenPersonalData.label",
	},
	hiddenPersonalDataRoleNotAllowed: {
		defaultMessage: "Your role is not allowed to view personal data",
		id: "common.hiddenPersonalData.reason.roleNotAllowed",
	},
	invalid: {
		defaultMessage: "Invalid",
		id: "common.invalid",
	},
	invisible: {
		defaultMessage: "Invisible",
		id: "common.invisible",
	},
	leadId: {
		defaultMessage: "Lead-ID",
		id: "common.leadId",
	},
	month: {
		defaultMessage: "Month",
		id: "common.month",
	},
	new: {
		defaultMessage: "New",
		id: "common.new",
	},
	no: {
		defaultMessage: "No",
		id: "common.no",
	},
	notAvailableInCarsalesLite: {
		defaultMessage: "This feature is not available in Car Sales Lite.",
		id: "common.notAvailableInCarsalesLite",
	},
	onlineOrderingDisabled: {
		defaultMessage: "Not available for online ordering.",
		id: "common.onlineOrderingDisabled.tooltip",
	},
	onlineOrderingEnabled: {
		defaultMessage: "Available for online ordering.",
		id: "common.onlineOrderingEnabled.tooltip",
	},
	onlyCapitalLetters: {
		defaultMessage: "Name with only capital letters is not allowed.",
		id: "common.onlyCapitalLetters",
	},
	open: {
		defaultMessage: "Open",
		id: "common.open",
	},
	porscheApproved: {
		defaultMessage: "Porsche Approved",
		id: "common.porscheApproved",
	},
	porscheApprovedShort: {
		defaultMessage: "Approved",
		id: "common.porscheApproved.short",
	},
	porscheFinancing: {
		defaultMessage: "Porsche Financing",
		id: "common.porscheFinancing",
	},
	print: {
		defaultMessage: "Print",
		id: "common.print",
	},
	proceed: {
		defaultMessage: "Proceed",
		id: "common.proceed",
	},
	retry: {
		defaultMessage: "Retry",
		id: "common.retry",
	},
	saveSuccess: {
		defaultMessage: "Successfully saved",
		id: "common.saveSuccess",
	},
	search: {
		defaultMessage: "Search",
		id: "common.search",
	},
	shareListingLinkHeadline: {
		defaultMessage: "Copy link to listing",
		id: "shareListingLink.modal.headline",
	},
	shareListingLinkSubheadline: {
		defaultMessage: "Choose your language and copy the link to the clipboard.",
		id: "shareListingLink.modal.subheadline",
	},
	showLess: {
		defaultMessage: "Show less",
		id: "common.showLess",
	},
	showMore: {
		defaultMessage: "Show more",
		id: "common.showMore",
	},
	since: {
		defaultMessage: "since {value}",
		id: "common.since",
	},
	vat: {
		defaultMessage: "Mwst",
		id: "common.vat",
	},
	vehicleCount: {
		defaultMessage: "{count, plural, one {# Vehicle} other {# Vehicles}}",
		id: "common.vehicleCount",
	},
	visible: {
		defaultMessage: "Visible",
		id: "common.visible",
	},
	visibleForCustomers: {
		defaultMessage: "Visible for customers",
		id: "common.visibleForCustomers",
	},
	visibleInternally: {
		defaultMessage: "Only visible internally",
		id: "common.visibleInternally",
	},
	warning: {
		defaultMessage: "Warning",
		id: "common.warning",
	},
	year: {
		defaultMessage: "Year",
		id: "common.year",
	},
	yes: {
		defaultMessage: "Yes",
		id: "common.yes",
	},
})
